// removed by extract-text-webpack-plugin
module.exports = {"flex":"src-components-modules-CompetitorAlternatives-style----logos-module---flex---2YL4I alignItems-center justifyContent-center breakPointL-display-flex breakPointL-textAlign-left","cta":"src-components-modules-CompetitorAlternatives-style----logos-module---cta---2k_-o paddingTop-l breakPointL-paddingLeft-m breakPointL-paddingTop-0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/CompetitorAlternatives/style/logos.module.css
// module id = 731
// module chunks = 21098653631116 260617349216052